import type { ReactElement } from "react";

import type {
    SignalNameSegment,
    SignalNameSelectionOverflow,
} from "app/pages/sales-intelligence/sub-modules/signals/models/miscellaneous/SignalNameSegments";
import type { SignalSelectionTooltipLabels } from "app/pages/sales-intelligence/sub-modules/signals/models/miscellaneous/SignalSelectionTooltipLabels";
import { getSignalTypeTooltipLabels } from "app/pages/sales-intelligence/sub-modules/signals/models/miscellaneous/SignalSelectionTooltipLabels";
import { hasSignalNameSelectionOverflow } from "app/pages/sales-intelligence/sub-modules/signals/utils/signalNameSelectionOverflow";

import SignalsSegmentTranslatable from "./SignalsSegmentTranslatable";
import { StyledSignalUpperText } from "./styles";

type Props = {
    signalType: SignalNameSegment;
    selectionOverflowOn?: SignalNameSelectionOverflow;
    selectionTooltipLabels?: SignalSelectionTooltipLabels;
};

const SignalsSegmentedSignalType = ({
    signalType,
    selectionOverflowOn,
    selectionTooltipLabels,
}: Props): ReactElement => {
    const overflowTooltipLabels = getSignalTypeTooltipLabels(selectionTooltipLabels);
    const showOverflowTooltip =
        (overflowTooltipLabels?.length ?? 0) > 1 && hasSignalNameSelectionOverflow(selectionOverflowOn, "signalType");

    return (
        <SignalsSegmentTranslatable
            as={StyledSignalUpperText}
            emphasize
            overflowTooltipLabels={overflowTooltipLabels}
            showOverflowTooltip={showOverflowTooltip}
            translatable={signalType}
        />
    );
};

export default SignalsSegmentedSignalType;
